module.exports = __webpack_public_path__ + "img/bg.2b9d4f83.png";